import {
  IMasterArtworkRequestHistory,
  MasterArtworkCollectionActionType,
  MasterArtworkCollectionActionTypes,
  MasterArtworkCollectionState,
} from "./data.type";

const initialState: MasterArtworkCollectionState = {
  name: "",
  code: "",
  licensor: null,
  licensed_property: null,
  launch_date: "",
  global_product: null,

  requestId: "",
  requestStatus: null,
  requestDateFrom: "",
  requestDateTo: "",
  requestor: "",
  approvedDateFrom: "",
  approvedDateTo: "",
  approver: "",

  requestHistory: [] as unknown as IMasterArtworkRequestHistory,
  submitComment: "",
  approveComment: "",
  rejectComment: "",
  rejectReason: null,
  hasUnsavedChanges: false,
  isValid: false,
  isReadOnly: false,
};

function reducer(
  state: MasterArtworkCollectionState,
  action: MasterArtworkCollectionActionType,
): MasterArtworkCollectionState {
  switch (action.type) {
    case MasterArtworkCollectionActionTypes.RESET_STATE:
      // @ts-ignore
      return initialState;

    case MasterArtworkCollectionActionTypes.SET_GLOBAL_PRODUCT:
      return {
        ...state,
        global_product: action.payload.global_product ?? null,
      };

    case MasterArtworkCollectionActionTypes.SET_COLLECTION:
      // @ts-ignore
      return action.payload;

    case MasterArtworkCollectionActionTypes.SET_LICENSOR:
      return {
        ...state,
        licensor: action.payload.licensor ?? null,
        licensed_property: null,
      };
    case MasterArtworkCollectionActionTypes.SET_LICENSED_PROPERTY:
      const licensor = !!action.payload.licensed_property
        ? action.payload.licensed_property?.licensor
        : state.licensor;
      return {
        ...state,
        licensed_property: action.payload.licensed_property ?? null,
        licensor: licensor,
      };
    case MasterArtworkCollectionActionTypes.SET_NAME:
      return {
        ...state,
        name: action.payload.name ?? "",
      };

    case MasterArtworkCollectionActionTypes.SET_CODE:
      return {
        ...state,
        code: action.payload.code?.toUpperCase() ?? "",
      };

    case MasterArtworkCollectionActionTypes.SET_LAUNCH_DATE:
      return {
        ...state,
        launch_date: action.payload.launch_date ?? "",
      };

    case MasterArtworkCollectionActionTypes.SET_SUBMIT_COMMENT:
      return {
        ...state,
        submitComment: action.payload.submitComment ?? "",
      };

    case MasterArtworkCollectionActionTypes.SET_APPROVE_COMMENT:
      return {
        ...state,
        approveComment: action.payload.approveComment ?? "",
      };

    case MasterArtworkCollectionActionTypes.SET_REJECT_COMMENT:
      return {
        ...state,
        rejectComment: action.payload.rejectComment ?? "",
      };

    case MasterArtworkCollectionActionTypes.SET_REJECT_REASON:
      return {
        ...state,
        rejectReason: action.payload.rejectReason ?? null,
      };

    case MasterArtworkCollectionActionTypes.SET_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: action.payload.requestStatus || null,
      };

    case MasterArtworkCollectionActionTypes.SET_IS_VALID:
      return {
        ...state,
        isValid: action.payload.isValid || null,
      };

    case MasterArtworkCollectionActionTypes.SET_IS_READ_ONLY:
      return {
        ...state,
        isReadOnly: action.payload.isReadOnly ?? false,
      };
  }

  return state;
}

export const isStateEqualToInitialState = (
  state: MasterArtworkCollectionState,
): boolean => {
  return Object.keys(initialState).every(
    (key) =>
      initialState[key as keyof MasterArtworkCollectionState] ===
      state[key as keyof MasterArtworkCollectionState],
  );
};

export const MasterArtworkCollectionReducer = { initialState, reducer };
